export const Modules = Object.freeze({
  SOLICITUD: 1 << 0, // 1
  COTIZACION: 1 << 1, // 2
  ESPECIFICACION_TECNICA: 1 << 2, // 4
  ORDEN_PRODUCCION: 1 << 3, // 8
});
